import {Col, ColType, Crud, optionOf} from "../../comp/crud";
import {ApiClient} from "../../api/ApiClient";
import '../clientConfig/index.scss'
import {useContext} from "react";
import {SiteInfoContext} from "../context/SiteInfoContext";

let apiClient = ApiClient.getDefault();
let cols: Col[] = [
    {
        name: "名称",
        key: "name",
        type: ColType.STRING,
        width: 200
    },
    {
        name: "Code",
        key: "code",
        type: ColType.STRING,
        width: 200
    },

    {
        name: "值",
        key: "items",
        render: (v) => v.join(", "),
        type: ColType.TAG,
        getOptions: (row) => {
            if(!row){
                return Promise.resolve([])
            }else {
                return Promise.resolve(row['items'].map((v: any) => { return {
                    value: v,
                    label: v
                }}))
            }

        }
    },
]
export default function Dict(){
    return <Crud
        canUpdate={true}
        canCreate={true}
        name="数据字典"
        entityKey="dicts"
        pageSize={50}
        cols={cols}
    />
}